export default __webpack_public_path__ + "static/media/gameDevSlider.345699e8.jpg";